const CarUseComponent = () => import('@/views/hrm/CarUse/CarUseView')

export default [
    {
        path:'/CarUseIndex',
        name:'CarUseComponent',
        component:CarUseComponent
    }
]